import React, { useState, useEffect, useRef, use } from 'react';
import { Col, Typography, Row, Button, Card, Input, Image, Layout, Modal } from 'antd';
import styled from 'styled-components';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import ReactPlayer from 'react-player';
import clip from 'src/sounds/clip-sound.mp3';
import clipGood from 'src/sounds/Good_job.mp3';
import clipTry from 'src/sounds/Try Again.mp3';
import 'react-simple-keyboard/build/css/index.css';
import useSound from 'use-sound';
import { isMobileOnly } from 'react-device-detect';
import { ImgButton } from 'src/components/Header/toolHeaderstyle';
import { useHistory } from 'react-router-dom';
import { CloseCircleOutlined } from '@ant-design/icons';
import FullScreenButton from 'src/components/common/FullScreenButton';
const { Header: HeaderWrapper } = Layout;
const { Title } = Typography;

const MainBlock = styled.div`
  padding: 10px;
  background: #fff;
  margin-top: 10px;
  height: calc(100vh - 94px);
`;

const TextBody = styled.div`
  border: 1px solid #000000e0;
  background: #c0daf1;
  margin-bottom: 40px;
  border-radius: 10px;
  padding: 5px;
  min-height: 60px;
  display: flex;
  padding-right: 80px;
  flex-flow: wrap;
  position: relative;
  @media (max-height: 700px) {
    margin-bottom: 20px;
  }
`;

const CardText = styled.div`
  color: #3293ef;
  font-size: 25px;
  margin-bottom: 0;
  text-align: center;
  @media (max-height: 700px) {
    font-size: 20px;
  }
  @media (max-width: 1080px) {
    font-size: 20px;
  }
`;

const AnswerText = styled.div`
  color: #3293ef;
  font-size: 20px;
  margin-bottom: 0;
  text-align: center;
  @media (max-height: 700px) {
    font-size: 20px;
  }
`;

const StyledInput = styled(Input)`
  color: #fff;
  z-index: 1;
  font-size: 30px;
  width: 90%;
  &::selection {
    color: #fff;
    background: #fff;
  }
`;

const TotalBox = styled.span`
  color: rgb(255, 122, 27);
  border: 1px solid #6b5c5c;
  padding: 5px 10px;
  border-radius: 5px;
`;

const ScoreBox = styled.span`
  color: #de3333;
  border: 1px solid #de3333ab;
  padding: 5px 10px;
  border-radius: 5px;
`;

const quesData = [
  {
    no: 1,
    eng: '<Hello>! [Hello]!',
    kor: '안녕 안녕',
    eng_audio: '/audio/Sentence VB1 UNIT1 A/0.mp4',
  },
  {
    no: 2,
    eng: '[<What>]’[s] <your> [name]?',
    kor: '넌 이름이 뭐니?',
    eng_audio: '/audio/Sentence VB1 UNIT1 A/1.mp4',
  },
  {
    no: 3,
    eng: 'My <name> [<is>] [Noonoo].',
    kor: '내 이름은 누누야.',
    eng_audio: '/audio/Sentence VB1 UNIT1 A/2.mp4',
  },
  {
    no: 4,
    eng: '[See] <you> later, [<Sammie>].',
    kor: '나중에 봐 새미야.',
    eng_audio: '/audio/Sentence VB1 UNIT1 A/3.mp4',
  },
  {
    no: 5,
    eng: '[<Good>] bye, [<Noonoo>].',
    kor: '잘 가 누누.',
    eng_audio: '/audio/Sentence VB1 UNIT1 A/4.mp4',
  },
];

const getUpdatedList = (quesData) => {
  for (let i = 0; i < quesData.length; i++) {
    let randDot = quesData[i]['eng'];
    randDot = randDot.replace(/[<>\[\]]*/g, '');
    quesData[i]['qns'] = randDot.split(' ');
    quesData[i]['ans'] = randDot;
    quesData[i]['eng_audio'] = quesData[i]['eng_audio'];
    quesData[i]['kor'] = quesData[i]['kor'];
  }

  return quesData;
};

// const data = getUpdatedList(quesData);

const ListenPage = ({ propsStageType, gotoNext, data, title = '', dataUserStudy, handleSaveExit, type }) => {
  const [total, setTotal] = useState(0);
  const [score, setScore] = useState(0);
  const [done, setDone] = useState(0);
  const [tries, setTries] = useState(4);
  const [stageType, setStageType] = useState(propsStageType ? propsStageType : 1);
  const [collapsed, setCollapsed] = useState(false);
  const [error, setError] = useState(false);
  const [answer, setAnswer] = useState('');
  const [selectedAns, setSelectedAns] = useState([]);
  const [ques, setQues] = useState('');
  const [indx, setIndx] = useState(0);
  const [text, setText] = useState('');
  const [playing, setPlaying] = useState(false);
  const [options, setOptions] = useState([]);
  const [play] = useSound(clip, { volume: 0.1 });
  const [playGood] = useSound(clipGood);
  const [playTry] = useSound(clipTry);
  const [answerSheet, setAnswerSheet] = useState([]);
  const history = useHistory();
  const tempArrRef = useRef([]);

  const sleep = (m) => new Promise((r) => setTimeout(r, m));

  useEffect(() => {
    if (data && data[done]) {
      setQues(data[done]['kor']);
      setAnswer(data[done]['ans']);

      // const allOptions = data
      //   .filter((d, i) => i !== done)
      //   .reduce((a, b) => {
      //     return b.qns.concat(a.qns ? a.qns : a);
      //   });

      // let restQ = allOptions.sort(() => Math.random() - 0.5).splice(0, 20 - data[done]['qns'].length);
      // restQ = restQ.concat(data[done]['qns']);
      // restQ = restQ.sort(() => Math.random() - 0.5);

      //only word cards in this sentence.

      const thisSentencePieces = data[done]['qns'].sort(() => Math.random() - 0.5);

      //setOptions(restQ);
      setOptions(thisSentencePieces);
      sleep(100);

      setPlaying(true);
      setTries(4);
      setTotal(data.length);
      setSelectedAns([]);
    }
  }, [done, data]);
  useEffect(() => {
    const tmpNum = type === 'sentence' ? 3 : 0;
    if (
      dataUserStudy &&
      dataUserStudy.getUserStudyCompleteList &&
      dataUserStudy.getUserStudyCompleteList[tmpNum]?.user_study_answer?.length >= 0&&
      dataUserStudy.getUserStudyCompleteList[tmpNum]?.stat ===0
    ) {
      const lastStudyData = dataUserStudy.getUserStudyCompleteList[tmpNum]?.user_study_answer;
      const lastIdx = lastStudyData.findIndex((v) => v.user_answer === '');
      let tmpscore = dataUserStudy.getUserStudyCompleteList[tmpNum]?.exam_correct;
      const tmp = data.map((e) => {
        let findAnswer = lastStudyData.find((a) => a.question_no === e.no);
        return {
          question_no: e.no,
          user_answer: findAnswer && findAnswer.user_answer !== '' ? findAnswer.user_answer : '',
          is_correct: findAnswer ? findAnswer.is_correct : '0',
        };
      });
      setScore(tmpscore);
      setAnswerSheet(tmp);
      setDone(lastIdx === -1 ? 0 : lastIdx);
    } else {
      const tmp = data.map((e) => {
        return {
          question_no: e.no,
          user_answer: '',
          is_correct: '0',
        };
      });
      setScore(data.length * 100);
      setAnswerSheet(tmp);
    }
  }, [dataUserStudy, data]);
  const handleCheck = () => {
    if (!tries) return;
    if (selectedAns.join(' ') === answer) {
      setSelectedAns([]);
      playGood();
      const tmp = [...answerSheet];
      tmp[done].user_answer = answer;
      tmp[done].is_correct = '1';
      setAnswerSheet(tmp);
      goNext();
    } else {
      const splitAns = answer.split(' ');
      const newSelected = [...selectedAns];
      let firstWrongIdx = -1;
      for (let i = 0; i < splitAns.length; i++) {
        if (newSelected[i] !== splitAns[i]) {
          newSelected[i] = '';
          if (firstWrongIdx === -1) firstWrongIdx = i;
        }
      }
      if (firstWrongIdx === -1) firstWrongIdx = 0;

      let newScore = tries === 2 ? score - 70 : score - 10;
      newScore = newScore < 0 ? 0 : newScore;

      setSelectedAns(newSelected);
      setScore(newScore);
      setIndx(firstWrongIdx);
      playTry();
      setError(true);
      setTimeout(function () {
        setError(false);
      }, 1000);
      setTries((prev) => prev - 1);

      if (tries < 2) {
        const tmp = [...answerSheet];
        tmp[done].user_answer = answer;
        tmp[done].is_correct = '0';
        setAnswerSheet(tmp);
        goNext();
      }
    }
  };
  const goNext = () => {
    setTimeout(() => {
      if (done < data.length - 1) {
        setIndx(0);
        setDone(done + 1);
      } else {
        if (gotoNext) {
          const calculatedScore = Math.round(score / total);
          gotoNext({ exam_total: 100, exam_correct: calculatedScore, message: `Your total score is ${calculatedScore}`,user_answers: answerSheet });
        }
      }
    }, 1000);
  };
  useEffect(() => {
    if (
      data[done]['qns'] &&
      indx >= data[done]['qns'].length &&
      !(selectedAns.length === data[done]['qns'].length && selectedAns.every((item, idx) => idx in selectedAns && Boolean(item)))
    ) {
      let falsyIdx = -1;
      for (let i = 0; i < data[done]['qns'].length; i++) {
        const hasValue = i in selectedAns;
        const value = selectedAns[i];
        const isFalsy = !value || !hasValue;
        if (isFalsy) {
          falsyIdx = i;
          setIndx(falsyIdx);
          break;
        }
      }
    }
  }, [indx]);
  const handleSelect = (i, value) => {
    selectedAns[i] = value;
    setSelectedAns(selectedAns);
    play();

    if (indx < data[done]['qns'].length) {
      let falsyIdx = -1;
      for (let i = indx; i < data[done]['qns'].length; i++) {
        const hasValue = i in selectedAns;
        const value = selectedAns[i];
        const isFalsy = !value || !hasValue;
        if (isFalsy) {
          falsyIdx = i;
          break;
        }
      }
      if (falsyIdx === -1) {
        setIndx(indx + 1);
      } else {
        setIndx(falsyIdx);
      }
    }
  };

  const handleUnSelect = (i) => {
    let tempS = selectedAns;
    delete tempS[i];
    tempS[i] = undefined;
    play();
    setSelectedAns(tempS);
    setIndx(i);
  };

  const onKeyPress = (button) => {
    button = button.key ? button.key : button;

    /**
     * If you want to handle the shift and caps lock buttons
     */
    play();
    if (button === '{enter}' || button.toLowerCase() === 'enter') handleCheck();
  };
  const handleCloseClick = () => {
    Modal.confirm({
      icon: null,
      title: 'Exit',
      content: (
        <Title level={4} style={{ textAlign: 'center', lineHeight: 2 }}>
          학습이 완료되지 않았습니다. <br /> 종료하면 지금 학습하던 문제부터 <br />
          이어서 학습합니다. <br /> 종료 하시겠습니까?
        </Title>
      ),
      onOk: () => {
        handleSaveExit({ user_answers: answerSheet, exam_total: 100 * total, exam_correct: score });
        history.push('/');
      },
    });
  };
  return (
    <>
      <HeaderWrapper
        style={{
          background: '#fff',
          paddingLeft: 10,
          paddingRight: 10,
          display: 'flex',
          justifyContent: 'space-between',
          position: 'relative',
          width: '100%',
          height: isMobileOnly && 50,
          lineHeight: isMobileOnly && '50px',
        }}
      >
        <div style={{ paddingTop: 10 }}>
          <Title level={2} style={{ marginLeft: 20, textTransform: 'capitalize', fontSize: isMobileOnly && 20 }}>
            {title}
          </Title>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {isMobileOnly && (
            <div style={{ backgroundColor: '' }}>
              <FullScreenButton
                element={<ImgButton className="header-btn" src="/images/fullscreen_blue.png" alt="back arrow in header" />}
                activeElement={<ImgButton className="header-btn" src="/images/fullscreenExit_blue.png" alt="back arrow in header" />}
              />
            </div>
          )}
          <div key="close" onClick={handleCloseClick}>
            <span style={{ color: '#999', cursor: 'pointer' }}>
              <CloseCircleOutlined
                style={{
                  marginRight: 20,
                  verticalAlign: 'middle',
                  fontSize: 25,
                  color: '#424242',
                }}
                key="close"
              />
            </span>
          </div>
        </div>
      </HeaderWrapper>
      <Col className="listenword-wrap" span={24} style={{ textAlign: 'left', margin: 0 }}>
        <MainBlock
          className="listenword-wrap-height scrollscroll"
          onKeyDown={onKeyPress}
          tabIndex={0}
          style={{ outline: 'none' }}
          onClick={() => collapsed && setCollapsed(false)}
        >
          <Row gutter={[24, 16]} style={{ padding: 10 }} className="listenword-txt">
            <Col span={16} className="listenword-heading">
              <Row gutter={[24, 16]} style={{ margin: 0 }}>
                <Col className="listenword-heading-main" span={24} style={{ padding: 10, paddingLeft: 10 }}>
                  <Title level={2} ellipsis>
                    <span style={{ color: '#065aa9', marginLeft: 10 }}>Unscramble the Sentence:</span>{' '}
                  </Title>
                </Col>
              </Row>
            </Col>
            <Col
              className="listenword-txt"
              span={8}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingRight: 10 }}
            >
              <Title level={4} style={{ margin: 0, marginLeft: 10, marginRight: 10 }}>
                <ScoreBox>Try : {tries}</ScoreBox>
              </Title>
              <Title level={4} style={{ margin: 0, marginLeft: 10, marginRight: 10 }}>
                <TotalBox>
                  {done + 1} / {total}
                </TotalBox>
              </Title>
              {collapsed ? (
                <MenuFoldOutlined
                  style={{
                    fontSize: 35,
                    transform: 'rotate(180deg)',
                    padding: 5,
                  }}
                  className="trigger"
                  onClick={() => setCollapsed(false)}
                />
              ) : (
                <MenuUnfoldOutlined
                  style={{
                    fontSize: 35,
                    transform: 'rotate(180deg)',
                    padding: 5,
                  }}
                  className="trigger"
                  onClick={() => setCollapsed(true)}
                />
              )}
            </Col>
          </Row>
          <Row gutter={[24, 16]}>
            <Col className="fordesktoponly" span={2} style={{ padding: 10, display: 'flex', justifyContent: 'flex-end' }}>
              {data[done] && stageType === 1 ? (
                <>
                  <Image
                    height={40}
                    width={40}
                    style={{ cursor: 'pointer', marginRight: 10 }}
                    src="/images/speak.png"
                    preview={false}
                    onClick={() => setPlaying(true)}
                  />
                  <ReactPlayer
                    url={`https://cdn.cloubot.com${data[done]['eng_audio']}`}
                    width="0"
                    height="0"
                    playing={playing}
                    onEnded={() => setPlaying(false)}
                  />
                </>
              ) : null}
            </Col>
            <Col span={20} style={{ padding: 0 }} className="searchkeyboard">
              {stageType === 2 ? (
                <Title level={4} style={{ width: '100%', background: '#c0daf1', padding: 10, borderRadius: 10 }}>
                  {ques}
                </Title>
              ) : null}
              <TextBody gutter={[10, 10]} className="searchtextbox">
                {data[done]['qns']
                  ? data[done]['qns'].map((a, i) => (
                      <Col
                        className="textfield"
                        key={i}
                        span={4}
                        onClick={() => handleUnSelect(i)}
                        style={{
                          margin: 3,
                          flex: 1,
                          padding: 5,
                          cursor: 'pointer',
                          marginRight: 10,
                          borderRadius: 10,
                          backgroundColor: '#fff',
                          borderColor: `${error ? '#da3a3a' : '#fdaa11'}`,
                          borderStyle: 'solid',
                          borderWidth: indx === i || error ? 3 : 0,
                        }}
                      >
                        <AnswerText>{selectedAns[i] ? selectedAns[i] : ''}</AnswerText>
                      </Col>
                    ))
                  : null}
                <Col
                  className="searchtextbox-btn"
                  style={{ padding: 0, overflow: 'visible', float: 'right', position: 'absolute', right: 0, zIndex: 50 }}
                >
                  <Button
                    disabled={
                      !(
                        selectedAns.length === answer.split(' ').length &&
                        selectedAns.every((item, idx) => idx in selectedAns && Boolean(item))
                      )
                    }
                    type="primary"
                    onClick={handleCheck}
                    style={{ float: 'right', width: '100%', height: '50px', right: 10 }}
                  >
                    Check
                  </Button>
                </Col>
              </TextBody>

              <Row gutter={[24, 16]} style={{ padding: 10, borderRadius: 10, border: '1px solid #aad8ff' }} className="btnkeyboard">
                {options
                  .reduce((acc, cur, _, orgArr) => {
                    //선택한 단어 카드 안 보이게 하도록 추가한 코드
                    //This is for hiding selected word card.
                    if (selectedAns.length > 0) {
                      const s = selectedAns.filter((item) => item === cur).length;
                      const o = orgArr.filter((item2) => item2 === cur).length;
                      if (s > 0) {
                        if (acc.filter((item3) => item3 === cur).length === o - s) {
                          return acc;
                        }
                      }
                    }
                    return [...acc, cur];
                  }, [])
                  .map((a, i) => {
                    return (
                      <Col className="keykey" onClick={() => handleSelect(indx, a)} key={i} span={4}>
                        <Card
                          style={{
                            backgroundColor: '#dfe3ea',
                            cursor: 'pointer',
                            borderRadius: 10,
                          }}
                          bodyStyle={{ padding: '20px 10px' }}
                        >
                          <CardText>{a}</CardText>
                        </Card>
                      </Col>
                    );
                  })}
              </Row>
            </Col>
          </Row>
        </MainBlock>
        {collapsed ? (
          <>
            <Card
              title="Word List"
              extra={
                <MenuFoldOutlined
                  style={{
                    fontSize: 35,
                    transform: 'rotate(180deg)',
                    padding: 5,
                  }}
                  className="trigger"
                  onClick={() => setCollapsed(false)}
                />
              }
              style={{
                width: 300,
                position: 'absolute',
                right: 0,
                height: 'calc(100% - 30px)',
                backgroundColor: '#dfe3ea',
                top: 20,
                opacity: 0.85,
                zIndex: 50,
              }}
            >
              {data.map((d, i) => (
                <Title level={4} key={i} style={{ marginBottom: 5, color: '#333333d9' }}>{`  ${i + 1}. ${done > i ? d.ans : '-'}`}</Title>
              ))}
            </Card>
          </>
        ) : null}
      </Col>
    </>
  );
};

export default ListenPage;
